import type {ILabel} from '../../../types'

export default {
    liveTv: <ILabel>{
        de: 'Live TV',
        en: 'Live',
        es: 'Live',
        fr: 'Live TV',
        nl: 'Live',
        it: 'Live',
    },
    bids: <ILabel>{
        de: 'Gebote',
        en: 'Bids',
        es: 'Pujas',
        fr: 'Offres',
        nl: 'Biedingen',
        it: 'Ordini',
    },
    program: <ILabel>{
        de: 'Programm',
        en: 'Schedule',
        es: 'Programa',
        fr: 'Programme',
        nl: 'Programma',
        it: 'Programma',
    }
}